import { PanelLeftDashed } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const PanelLeftDashedIcon = createLucideIcon(PanelLeftDashed);
